module.exports = __webpack_public_path__ + "media/images/logos/BFM_logo-95b2346e3de1aacbcd2397962c2c7c0b.png";